import {formatToPersianAddComma, parseToEnRemoveComma,} from "./CommaSeparator";
import NumericFunction from "./NumericFunction";
import numeric from "./NumericFunction";

const sum = (values, data, calcParams) => {
  for (let value of values) {
    value = +parseToEnRemoveComma(value);
  }
  values = values.map((v) => +parseToEnRemoveComma(v));

  let result =  (values.reduce((acc, value) => acc + +value, 0));
  // if(+numeric.p2e(result)===+"0"){
  //   return 0
  // }
  result = +result.toFixed(2)
  return formatToPersianAddComma(result)
};

const persianNumberFormatter = (cell, formatterParams, onRendered) => {
  let temp = cell.getValue() + "";

  return NumericFunction.e2p(temp)
}
const separateNumbers = (cell, formatterParams, onRendered) => {
  let temp = cell.getValue() + "";
  if (temp.includes(",")) {
    temp = temp.replaceAll(",", "");
  }
  if (temp.includes("(") || temp.includes(")")) {
    temp = temp.replaceAll(")", "");
    temp = temp.replaceAll("(", "");
    return "(" + formatToPersianAddComma(temp) + ")";
  }

  return formatToPersianAddComma(temp);
};

const persianDigits = (cell, formatterParams, onRendered) => {
  let temp = cell.getValue() + "";
  temp = numeric.e2p(temp)
  return (temp);
};


function addSeparator(cols, fields) {
  if (fields !== undefined) {
    if (fields.length > 0) {
      for (let col of cols) {
        if (fields.includes(col.field)) {
          col.formatter = tableCalc.separateNumbers;
          col.topCalc = tableCalc.sum;
          // col.topCalc = "sum";
        }
      }
    }
  }
}

function addSeparatorToSingleColumn(cols, fields) {
  if (fields !== undefined) {
    if (fields.length > 0) {
      for (let col of cols) {
        if (fields.includes(col.field)) {
          col.formatter = tableCalc.separateNumbers;
          // col.topCalc = tableCalc.sum;
          // col.topCalc = "sum";
        }
      }
    }
  }
}


function addSeparatorAndAddBottomCalc(cols, fields) {
  if (fields !== undefined) {
    if (fields.length > 0) {
      for (let col of cols) {
        if (fields.includes(col.field)) {
          col.formatter = tableCalc.separateNumbers;
          col.bottomCalc = tableCalc.sum;
          // col.topCalc = "sum";
        }
      }
    }
  }
}

function AddEditButtonToLastColumns(
  cols,
  newTitle = "عنوان جدید",
  formatter = function (cell, formatterParams, onRendered) {
    //plain text value
    return '<i class="fa fa-edit"></i>';
  },
  width = 60,
  callBack
) {
  const lastColumn = {
    title: newTitle,
    headerSort: false,
    formatter: formatter,
    hozAlign: "center",
    width: width,
    headerHozAlign: "center",
    cellClick: function (e, cell) {
      callBack(e, cell);
    },
  };

  cols.push(lastColumn);
}

const tableCalc = {
  persianDigits,
  sum,
  separateNumbers,
  addSeparatorToSingleColumn,
  addSeparator,
  addSeparatorAndAddBottomCalc,
  AddEditButtonToLastColumns,
  persianNumberFormatter,
};

export default tableCalc;
